module.exports = __webpack_public_path__ + "img/logo.a6201cc9.png";